function emojiToCodePoint(emoji) {
  // Convert emoji string to twemoji codepoint (e.g. "🇵🇭" → "1f1f5-1f1ed")
  let result = "";
  let i = 0;
  while (i < emoji.length) {
    const code = emoji.codePointAt(i);
    if (code === 0x200D) { result += "-200d"; i += 1; continue; } // ZWJ
    if (code === 0xFE0F) { i += 1; continue; } // variation selector - skip
    if (result) result += "-";
    result += code.toString(16);
    i += (code > 0xFFFF ? 2 : 1);
  }
  return result;
}

export function TwemojiImg({ emoji, size = 18, style = {} }) {
  const cp = emojiToCodePoint(emoji);
  if (!cp) return <span style={{ fontSize: size, ...style }}>{emoji}</span>;
  const src = `https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/${cp}.png`;
  return (
    <img
      src={src}
      alt={emoji}
      draggable={false}
      style={{ width: size, height: size, display: "inline-block", verticalAlign: "middle", objectFit: "contain", ...style }}
      onError={e => {
        // Fallback: if image fails, show raw emoji text
        e.target.style.display = "none";
        e.target.insertAdjacentText("afterend", emoji);
      }}
    />
  );
}
